import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  getGradingExercisesLoad,
  getGradingExercisesLoadFailure,
  getGradingExercisesLoadSuccess,
} from "../../actions/grading-exercises/get-grading-exercises.actions";
import { GradingExercise } from "src/app/shared/interfaces/grading-exercise";

export interface GradingExercisesListState {
  exercises: GradingExercise[] | null;
  error: HttpErrorResponse | null;
}

const initialState: GradingExercisesListState = {
  exercises: null,
  error: null,
};

export const gradingExercisesListReducer = createReducer(
  initialState,
  on(
    getGradingExercisesLoad,
    (state): GradingExercisesListState => ({
      ...state,
      exercises: null,
      error: null,
    }),
  ),
  on(
    getGradingExercisesLoadSuccess,
    (state, action): GradingExercisesListState => ({
      ...state,
      exercises: action.exercises,
      error: null,
    }),
  ),
  on(getGradingExercisesLoadFailure, (state, { error }) => ({
    ...state,
    error: error,
  })),
);
